import React from 'react';
import {Button, Stack} from '@mui/material';
import {Drawer} from 'presentation/components/Drawer';
import {translations} from 'presentation/translations-new/index';
import {ContextMenuProps} from './types';

const {exclude, edit} = translations['pt-br'].commons;
const {assignToDependent} = translations['pt-br'].privateFlow.bookingFlow.location;

export function MobileContextMenu({
	isMenuOpen,
	handleContextMenuClose,
	handleEdit,
	handleDelete,
	handleAssignToDependent,
	showAssignToDependent,
}: ContextMenuProps) {
	return (
		<Drawer.Root
			open={isMenuOpen}
			onOpen={() => {}}
			onClose={handleContextMenuClose}
			swipeAreaWidth={0}>
			<Drawer.Footer hideFirstButton hideSecondButton>
				<Stack direction="column-reverse" gap={2}>
					{handleDelete && (
						<Button
							variant="outlined"
							color="error"
							size="large"
							fullWidth
							data-tag-id="context-menu-delete"
							onClick={() => {
								handleContextMenuClose();
								handleDelete();
							}}>
							{exclude}
						</Button>
					)}
					{showAssignToDependent && handleAssignToDependent && (
						<Button
							variant="outlined"
							size="large"
							fullWidth
							data-tag-id="context-menu-assign-to-dependent"
							onClick={() => {
								handleContextMenuClose();
								handleAssignToDependent();
							}}>
							{assignToDependent.menuLabel}
						</Button>
					)}
					<Button
						variant="outlined"
						size="large"
						fullWidth
						data-tag-id="context-menu-edit"
						onClick={() => {
							handleContextMenuClose();
							handleEdit();
						}}>
						{edit}
					</Button>
				</Stack>
			</Drawer.Footer>
		</Drawer.Root>
	);
}
